import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from 'server';
import { UserModel, IUserModel } from './models/user.models';
import { UserView, UserData } from './types';
const { model, array, maybeNull, reference, string } = types;

export const UserTableStore = model('GroupTableStore', {
  userGroup: array(UserModel),
  filter: string,
  clickedUser: maybeNull(reference(UserModel)),
})
  .views((self) => ({
    get usergroupsView(): UserView[] {
      if (!self.userGroup || self.userGroup.length === 0) {
        return [];
      }
      const usersView: UserView[] = [];
      for (let i = 0; i < self.userGroup.length; i++) {
        const userGroupItem = self.userGroup[i];
        const userView: UserView = { ...userGroupItem, id: i };
        usersView.push(userView);
      }
      if (!self.filter) {
        return usersView;
      }
      const regexp = new RegExp(self.filter, 'i');
      const filteredUserGroupsView = usersView.filter(({ mail, sn, uid, givenname }) =>
        regexp.test(`${mail}${sn}${uid}${givenname}`)
      );
      return filteredUserGroupsView;
    },
    get CurrentClickedUser() {
      return self.clickedUser;
    },
  }))
  .actions((self) => ({
    clearClickedUser() {
      self.clickedUser = null;
    },
  }))
  .actions((self) => ({
    normalizeuserGroup({ data }: AxiosResponse): IUserModel[] {
      self.userGroup.replace(data.data);
      return self.userGroup;
    },
    setFilter(filter: string) {
      self.filter = filter;
    },

    setClickedUser(dn: string): void {
      self.clickedUser = self.userGroup.find((user) => user.dn === dn) || null;
    },
    clearSelected(): void {
      self.clickedUser = null;
    },
  }))

  .actions((self) => ({
    createUserGroup: flow(function* (data: UserData, dn) {
      const result = yield axios
        .post<IUserModel>(`groups/${dn}/users`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));
export type IUserTableStore = Instance<typeof UserTableStore>;
